import { memberApi } from "./client";

export interface CourseTopic {
  id: string; title: string; position: number; revision: number;
  starts_on: string | null; ends_on: string | null; updated_at: string;
  published_revision: number | null; published_purpose: string | null; published_at: string | null;
  draft?: { revision: number; purpose: string; saved_at: string } | null;
}
export interface TopicSession {
  id: string; session_no: number; starts_at: string; ends_at: string; status: string; topic_id: string | null;
}
export interface CourseTopics {
  course_id: string; course_status: string; timezone: string; read_at: string;
  can_edit: boolean; can_publish: boolean; topics: CourseTopic[]; sessions: TopicSession[]; membership_token: string;
}
export interface TopicContent { title: string; purpose: string; starts_on: string | null; ends_on: string | null }
export interface TopicReceipt {
  state: "confirmed"; topic_id: string; revision?: number; purpose_revision?: number;
  published_revision?: number; waiting_for_course?: boolean; session_ids?: string[]; membership_token?: string;
}
const route = (course: string) => `/courses/${course}/topics`;
const keyed = (key: string) => ({ headers: { "Idempotency-Key": key } });
export const courseTopicsApi = {
  read: (course: string, preparation = false) => memberApi.get<CourseTopics>(`${route(course)}${preparation ? "/preparation" : ""}`),
  create: (course: string, body: TopicContent & { id: string }, key: string) => memberApi.post<TopicReceipt>(route(course), body, keyed(key)),
  save: (course: string, topic: string, body: TopicContent & { revision: number; purpose_revision: number }, key: string) => memberApi.put<TopicReceipt>(`${route(course)}/${topic}`, body, keyed(key)),
  publish: (course: string, topic: string, body: { purpose_revision: number; published_revision: number | null }, key: string) => memberApi.post<TopicReceipt>(`${route(course)}/${topic}/publish`, body, keyed(key)),
  place: (course: string, topic: string, body: { session_ids: string[]; membership_token: string }, key: string) => memberApi.put<TopicReceipt>(`${route(course)}/${topic}/sessions`, body, keyed(key)),
};
export const topicVersion = (topic: CourseTopic) => `${topic.revision}/${topic.draft?.revision ?? 0}`;
